import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import moment from "moment";
import "moment/locale/es";

import enCommon from "./locales/en/common.json";
import enAdmin from "./locales/en/admin.json";
import enActivity from "./locales/en/activity.json";
import enAuth from "./locales/en/auth.json";
import enDashboard from "./locales/en/dashboard.json";
import enAthletePortal from "./locales/en/athlete-portal.json";
import enCoachingPortal from "./locales/en/coaching-portal.json";
import enBookTour from "./locales/en/book-tour.json";
import enNews from "./locales/en/news.json";
import esCommon from "./locales/es/common.json";
import esAdmin from "./locales/es/admin.json";
import esActivity from "./locales/es/activity.json";
import esAuth from "./locales/es/auth.json";
import esDashboard from "./locales/es/dashboard.json";
import esAthletePortal from "./locales/es/athlete-portal.json";
import esCoachingPortal from "./locales/es/coaching-portal.json";
import esBookTour from "./locales/es/book-tour.json";
import esNews from "./locales/es/news.json";

const defaultNS = "common";

const resources = {
  en: {
    [defaultNS]: enCommon,
    admin: enAdmin,
    activity: enActivity,
    auth: enAuth,
    dashboard: enDashboard,
    "athlete-portal": enAthletePortal,
    "coaching-portal": enCoachingPortal,
    "book-tour": enBookTour,
    news: enNews,
  },
  es: {
    [defaultNS]: esCommon,
    admin: esAdmin,
    activity: esActivity,
    auth: esAuth,
    dashboard: esDashboard,
    "athlete-portal": esAthletePortal,
    "coaching-portal": esCoachingPortal,
    "book-tour": esBookTour,
    news: esNews,
  },
};

const baseConfig = {
  resources,
  defaultNS,
  fallbackLng: "en",
  supportedLngs: ["en", "es"],
  interpolation: {
    escapeValue: false,
  },
};

if (process.browser) {
  const initialLanguage = window.__INITIAL_LANGUAGE__ || undefined;

  // When the user has a saved language preference, skip LanguageDetector
  // entirely to prevent the browser/cookie-detected language from overriding
  // the server-authoritative preference after init.
  if (initialLanguage) {
    i18n.use(initReactI18next).init({
      ...baseConfig,
      lng: initialLanguage,
    });
  } else {
    i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        ...baseConfig,
        detection: {
          order: ["querystring", "cookie", "navigator"],
          caches: ["cookie"],
        },
      });
  }
} else {
  // Server: initialize synchronously so SSR does not suspend (no LanguageDetector)
  i18n.use(initReactI18next).init({
    ...baseConfig,
    lng: "en",
    react: { useSuspense: false },
  });
}

const syncMomentLocale = (lng) => {
  const base = (lng || "en").split("-")[0];
  moment.locale(base);
};

syncMomentLocale(i18n.resolvedLanguage || i18n.language);
i18n.on("languageChanged", syncMomentLocale);

export default i18n;
